import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { update as updateRubric } from 'js/actions/rubric-actions';
import { LoadingMessage } from 'js/components';
import { RubricWeightsProvider } from '../components/RubricWeights/RubricWeightsContext';
import RubricWeightsComponent from '../components/RubricWeights/RubricWeightsComponent';

function RubricWeightsContainer({
  workspaceId,
  rubricId,
  rubric,
  rubricLoadFailed,
  updateRubric,
}) {
  const handleSave = useCallback(
    (payload) => updateRubric(rubricId, payload),
    [updateRubric, rubricId]
  );

  const rubricSyncKey = useMemo(() => {
    if (!rubric?.id) return null;
    const u = rubric?.updated_at;
    const updatedTick =
      u == null ? '' : u instanceof Date ? u.getTime() : String(u);
    return `${rubric.id}:${updatedTick}`;
  }, [rubric?.id, rubric?.updated_at]);

  if (!rubric && !rubricLoadFailed) {
    return <LoadingMessage iconSize="2x">Loading rubric…</LoadingMessage>;
  }

  if (!rubric) {
    return null;
  }

  return (
    <RubricWeightsProvider rubric={rubric} rubricSyncKey={rubricSyncKey}>
      <RubricWeightsComponent workspaceId={workspaceId} onSave={handleSave} />
    </RubricWeightsProvider>
  );
}

export default connect(null, { updateRubric })(RubricWeightsContainer);
